<template>
  <custom-dialog width="500px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <!-- 用户信息 -->
      <el-form :model="form" :rules="rules" :validate-on-rule-change="false" ref="form">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('invoice_dialog.ming_cheng')" prop="buyerName">
              <el-input v-model="form.buyerName" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('invoice_dialog.shui_hao')" prop="buyerNumber">
              <el-input v-model="form.buyerNumber" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('invoice_dialog.dan_wei_di_zhi')" prop="buyerRegisterAddress">
              <el-input v-model="form.buyerRegisterAddress" type="textarea" :rows="2" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('invoice_dialog.dian_hua_hao_ma')" prop="buyerMobile">
              <el-input v-model="form.buyerMobile" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('invoice_dialog.kai_hu_yin_hang')" prop="buyerDepositBank">
              <el-input v-model="form.buyerDepositBank" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('invoice_dialog.yin_hang_zhang_hao')" prop="buyerDepositNumber">
              <el-input v-model="form.buyerDepositNumber" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('Common.com_email')" prop="buyerEmail">
              <el-input
                v-model.trim="form.buyerEmail"
                placeholder=""
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="warning" @click="saveGroup">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],

  data() {
    return {
      form: {
        buyerDepositBank: '', // 买方银行卡开户支行
        buyerDepositNumber: '', // 买方银行账号
        buyerMobile: '', // 买方电话号码
        buyerName: '', // 买方名称（发票抬头）
        buyerNumber: '', // 买方纳税人识别号
        buyerRegisterAddress: '', // 买方注册地址
        partnerInvoiceId: null, // 主体id [编辑时不为空]
        buyerEmail: ''
      },

      editOff: false,
    };
  },
  computed: {
    rules() {
      return {
        buyerNumber: {
          required: true,
          message: this.$t('invoice_dialog.shui_hao_bi_tian'),
        },
        buyerName: {
          required: true,
          message: this.$t('invoice_dialog.ming_cheng_bi_tian'),
        },
        buyerMobile: [
          {
            required: true,
            message: this.$t('invoice_dialog.dhhmbt'),
          },
        ],
        buyerDepositNumber: {
          required: true,
          message: this.$t('invoice_dialog.yhzhbt'),
        },

        buyerDepositBank: {
          required: true,
          message: this.$t('invoice_dialog.khyhbt'),
        },
        buyerRegisterAddress: {
          required: true,
          message: this.$t('invoice_dialog.dwdzbt'),
        },
        buyerEmail: [
          {
            type: 'email',
            message: this.$t('invoice_dialog.yxgsbzq'),
          },
          { max: 50, message: ' ' }
        ]
      };
    }
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      if (this.model.type === 'add') {
        this.editOff = false;
      }
      if (this.model.type === 'edit') {
        this.$setFormatData(this.form, this.model.data);
        this.pushConfId = this.model.data.pushConfId;
        // 编辑 disabled
        this.editOff = true;
      }
    },

    // 确认保存分组
    saveGroup: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.model.type === 'add') {
          this.saveAddItem();
        }
        if (this.model.type === 'edit') {
          this.saveEditItem();
        }
      });
    },
    // 保存新增分组
    saveAddItem: function () {
      this.$postJSON(apis.crmPartnerInvoiceAdd, this.form, true).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.visible = false;
        this.$emit('success');
      });
    },
    saveEditItem: function () {
      this.$postJSON(apis.crmPartnerInvoiceUpdate, this.form, true).then(() => {
        if (this.model.type === 'add') {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
        } else if (this.model.type === 'edit') {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
        }
        this.visible = false;
        this.$emit('success');
      });
    },
  },
};
</script>

<style lang="scss"></style>
